import { ModalInput } from "components/atoms/input/modal/ModalInput";
import * as s from "./ContactStyled";
import { parsePhoneNumber } from "react-phone-number-input";
import { ReactComponent as EmptyIcon } from "assets/icons/empty_information.svg";
import { ContactInfoResponse } from "api/interfaces/helpInterface.interface";
import { ContactInfoItemKey } from "pages/setting/information/InformationContainer";
import Spinner from "components/atoms/loader/Spinner";
import CenterContentPage from "components/templates/layout/CenterContentPage";

export default function TechSupportPresenter({
  data,
  isLoading,
}: {
  data?: ContactInfoResponse;
  isLoading: boolean;
}) {
  return (
    <CenterContentPage titleComponent="Contact">
      {isLoading ? (
        <Spinner isCenter />
      ) : !data?.id ||
        ContactInfoItemKey.reduce(
          (acc, key) => acc + (data?.[key] || []).length,
          0
        ) === 0 ? (
        <s.EmptyContainer>
          <EmptyIcon />
          <p>
            <b>No Information</b>
          </p>
        </s.EmptyContainer>
      ) : (
        <ContactInfo data={data} />
      )}
    </CenterContentPage>
  );
}

export const ContactInfo = ({ data }: { data: ContactInfoResponse }) => {
  return (
    <>
      {(data?.sites || []).length > 0 && (
        <ModalInput label={"Site"} essential={false}>
          {data.sites.map((site, index) => (
            <s.Item key={index}>
              <a
                href={
                  site.site.includes("http")
                    ? site.site
                    : `https://${site.site}`
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {site.site}
              </a>
            </s.Item>
          ))}
        </ModalInput>
      )}
      {(data?.emails || []).length > 0 && (
        <ModalInput label={"Email"} essential={false}>
          {data.emails.map((email, index) => (
            <s.Item key={index}>
              <a href={`mailto:${email.email}`}>{email.email}</a>
              {email.description && <small>{email.description}</small>}
            </s.Item>
          ))}
        </ModalInput>
      )}
      {(data?.phones || []).length > 0 && (
        <ModalInput label={"Phone"} essential={false}>
          {data.phones.map((phone, index) => (
            <s.Item key={index}>
              {parsePhoneNumber(phone.phone)?.formatInternational()}
              {phone.description && <small>{phone.description}</small>}
            </s.Item>
          ))}
        </ModalInput>
      )}
      {(data?.customFields || []).length > 0 && (
        <ModalInput label={"Custom"} essential={false}>
          {data.customFields.map((customField, index) => (
            <s.Item key={index}>
              {customField.label}
              <small>{customField.value}</small>
            </s.Item>
          ))}
        </ModalInput>
      )}
    </>
  );
};
